import type { CityConfig } from "../city-template/types";

export const fountainConfig: CityConfig = {
  city: "Fountain",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "fountain",
  route: "/cities/fountain",
  title: "Emergency Passport Fountain, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Fountain, Colorado — as fast as 24 hours. Same-day courier processing for Fountain, Fort Carson, Security-Widefield, Colorado Springs, and all El Paso County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Fountain, CO",
  heroSubtitle: "Military deployment or PCS move overseas coming up fast? Family vacation and you need passports for the whole crew? We help Fountain residents — from Fort Carson soldiers and families to Security-Widefield homeowners to El Paso County professionals — get their passports quickly. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Fountain%20Colorado%20high%20plains%20landscape%20with%20Pikes%20Peak%20mountain%20dominating%20the%20western%20skyline%20on%20a%20clear%20day%2C%20the%20Fountain%20Creek%20corridor%20winding%20through%20semi%20arid%20grasslands%2C%20suburban%20residential%20neighborhoods%20with%20modern%20homes%20and%20distant%20mountain%20views%2C%20the%20Fort%20Carson%20military%20base%20visible%20in%20the%20distance%2C%20dramatic%20Colorado%20blue%20sky%20with%20golden%20prairie%20light%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view%20with%20warm%20earth%20tones%20and%20expansive%20skylines&width=1800&height=700&seq=fountain-hero-001&orientation=landscape",
  heroImageAlt: "Fountain Colorado with Pikes Peak mountain views and the Fountain Creek corridor",
  geoPosition: "38.6822;-104.7008",
  geoPlacename: "Fountain, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 75 miles north via I-25 — about 1 hour and 15 minutes",
  },
  nearbyCitiesZips: [
    { name: "Fountain", zips: "80817" },
    { name: "Fort Carson", zips: "80902, 80913" },
    { name: "Security-Widefield", zips: "80911, 80925" },
    { name: "Colorado Springs", zips: "80903, 80905, 80906, 80907, 80909, 80910" },
    { name: "Manitou Springs", zips: "80829" },
    { name: "Stratmoor", zips: "80906" },
    { name: "Cimarron Hills", zips: "80915" },
    { name: "Pueblo", zips: "81001, 81003, 81004" },
    { name: "Rock Creek Park", zips: "80926" },
    { name: "Hanover", zips: "80817" },
    { name: "Pinon", zips: "80928" },
    { name: "Wigwam", zips: "80928" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Fountain international departures — military and civilian" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the 75-mile drive to Aurora" },
    { icon: "ri-flight-takeoff-line", title: "COS & DEN Airport Service", desc: "Serving Colorado Springs and Denver International airports" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from UPS or FedEx in Fountain, Security, or Colorado Springs" },
  ],
  internalLinks: [
    { name: "Expedited passport in Colorado Springs, CO", route: "/cities/colorado-springs" },
    { name: "Emergency passport help in Pueblo, CO", route: "/cities/pueblo" },
    { name: "Fast passport renewal in Fountain area", route: "/cities/fountain" },
    { name: "Urgent passport services for Fort Carson military families", route: "/cities/fountain" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Security-Widefield", route: "/cities/fountain" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Fountain remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Fountain's location in southern El Paso County — 75 miles from the Colorado Passport Agency — makes our courier service essential. Skip the 1+ hour drive up I-25 and let us handle everything — especially valuable for Fort Carson military families with tight PCS timelines.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Fountain, Fort Carson, Security-Widefield, and southern El Paso County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Fountain and the surrounding southern El Paso County area. From the neighborhoods near Fountain-Fort Carson High School to the communities along Mesa Ridge Parkway, from the Fort Carson gates to the residential areas of Security-Widefield — we serve every corner of Fountain and the surrounding communities.",
  nearbyCitiesIntro: "We serve Fountain and all nearby communities including Fort Carson, Security-Widefield, Colorado Springs, Stratmoor, Manitou Springs, Pueblo, and all of southern El Paso County.",
  howItWorksIntro: "Most Fountain travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — you never need to drive 75 miles up I-25 to Aurora. This is especially important for military families on tight PCS timelines.",
  mistakesIntro: "Fountain is a military community anchored by Fort Carson, with growing residential suburbs and families. Here are the most common passport mistakes we see from Fountain-area travelers.",
  testimonialsIntro: "Fountain travelers — from Fort Carson soldiers and their families to Security-Widefield residents to El Paso County professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Fountain, CO? Here are the most common ones we hear from El Paso County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (75 miles, 1hr 15min each way)", "I-25 corridor traffic through Denver unpredictable"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Fountain", "Perfect for military PCS and family relocation", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Fountain travelers — military and civilian — with immediate departure needs. As fast as 24 hours without the 75-mile drive to Aurora.",
      bullets: ["24–48 hour turnaround available", "Military PCS and deployment support", "COS and DEN airport departure coordination"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Fountain adults with a passport issued within the last 15 years. Skip the post office — we handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Fountain address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Fountain residents and military families — including newborns and new citizens.",
      bullets: ["Acceptance facility scheduling in Fountain or Colorado Springs", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Fountain residents — especially critical for military families on PCS timelines.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Fountain military and civilian families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes — common for military families.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Military name change documentation expertise"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Fountain CO", description: "Urgent passport processing for Fountain Colorado travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Fountain CO", description: "Fast passport renewal for Fountain Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Fountain CO", description: "New passport application services for Fountain Colorado residents applying for their first passport." },
    { name: "Child Passport Fountain CO", description: "Minor passport services for Fountain Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "SGT Michael B.",
      location: "Fort Carson, CO — Fountain",
      rating: 5,
      text: "PCS orders to Germany with 3 weeks notice. My wife and two kids needed passports fast. Fast Passport Center got all three done in 5 days. Ship from the UPS Store in Fountain and everything was perfect. A lifesaver for military families.",
      service: "Military Family Passport Bundle",
    },
    {
      name: "Angela R.",
      location: "Fountain, CO — Mesa Ridge",
      rating: 5,
      text: "Family reunion in the Philippines and our kids' passports had expired. Fast Passport Center handled the renewals in 4 days. Being so far from Denver, the courier service is absolutely essential.",
      service: "Family Passport Renewal",
    },
    {
      name: "CPT David K.",
      location: "Fort Carson, CO",
      rating: 5,
      text: "Official passport needed for NATO assignment on short notice. Fast Passport Center understood military requirements and got it done in 3 days. No need to drive 75 miles to Denver — everything handled remotely.",
      service: "Emergency Official Passport",
    },
    {
      name: "Maria V.",
      location: "Security-Widefield, CO",
      rating: 5,
      text: "First-time passports for my three kids heading to visit grandparents in Mexico. Fast Passport Center made the whole process easy and got all three passports in 6 days. Incredible service for our community.",
      service: "Family Passport Bundle",
    },
  ],
  facilities: [
    {
      id: "fnt-1",
      name: "Fountain Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7745 S US Highway 85-87",
      city: "Fountain",
      state: "CO",
      zip: "80817",
      phone: "(719) 382-5621",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Central Fountain, along the Highway 85-87 corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Fountain acceptance facility. Limited appointment slots — book well in advance. Serves Fountain, Fort Carson, and Security-Widefield residents.",
      icon: "ri-mail-line",
    },
    {
      id: "fnt-2",
      name: "Fort Carson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1635 Wickersham Blvd",
      city: "Fort Carson",
      state: "CO",
      zip: "80913",
      phone: "(719) 526-2811",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Within Fort Carson base — access requires military ID",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "On-base acceptance facility for active duty military, dependents, and retirees. Military ID required for base access. Limited hours — call ahead. Serves Fort Carson personnel.",
      icon: "ri-shield-line",
    },
    {
      id: "fnt-3",
      name: "Colorado Springs Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E Pikes Peak Ave",
      city: "Colorado Springs",
      state: "CO",
      zip: "80903",
      phone: "(719) 570-5336",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 12 miles north of Fountain, in downtown Colorado Springs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in the region. Downtown Colorado Springs location. More appointment availability than Fountain. Approximately 15-minute drive from Fountain.",
      icon: "ri-mail-line",
    },
    {
      id: "fnt-4",
      name: "El Paso County Clerk & Recorder — Citizens Service Center",
      type: "County Clerk Passport Acceptance",
      address: "1675 W Garden of the Gods Rd",
      city: "Colorado Springs",
      state: "CO",
      zip: "80907",
      phone: "(719) 520-6200",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Approximately 15 miles north of Fountain, in Colorado Springs",
      website: "https://clerkandrecorder.elpasoco.com/",
      websiteLabel: "El Paso County Clerk",
      notes: "County government passport acceptance with extended hours (8AM–5PM). Serves all El Paso County residents. Good for early morning appointments before work.",
      icon: "ri-government-line",
    },
    {
      id: "fnt-5",
      name: "Security Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5755 Kittery Dr",
      city: "Colorado Springs",
      state: "CO",
      zip: "80911",
      phone: "(719) 392-4511",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 5 miles north of Fountain, in Security",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Security-Widefield residents. Closer than Colorado Springs for northern Fountain communities. Limited appointments — call ahead.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 75-mile drive to Aurora via I-25", fpc: "No — ship from Fountain" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "I-25 Corridor Distance", agency: "75 miles each way — 2.5hr round trip", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Not Planning Around PCS Timelines",
      description: "Military families at Fort Carson receive PCS orders with specific reporting dates. Routine passport processing takes 8–11 weeks — too slow for most PCS timelines. Start expedited service as soon as you receive orders.",
    },
    {
      icon: "ri-image-line",
      title: "Using Non-Compliant Photos for Official Passports",
      description: "Official (government/military) passports have different photo requirements than tourist passports. Using tourist passport photos for official passport applications will cause rejection. Verify photo requirements with your command.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Considering Fort Carson Post Office",
      description: "Active duty military and dependents can use the Fort Carson Post Office for passport acceptance — it's often less crowded than civilian facilities. Military ID required for base access.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating the Distance to Denver",
      description: "Fountain to the Colorado Passport Agency is 75 miles and about 1 hour 15 minutes each way without traffic. With I-25 corridor congestion, it can easily be 1.5+ hours each way. Our courier service eliminates this 2.5+ hour round trip entirely.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Country-Specific Military Requirements",
      description: "Military personnel PCSing overseas may need both official and tourist passports. Different countries have different SOFA (Status of Forces Agreement) requirements. Verify with your personnel office before applying.",
    },
    {
      icon: "ri-parent-line",
      title: "Not Having Both Parents Present for Minor Passports",
      description: "Military families often have one parent deployed or TDY. Both parents must consent for a minor's passport — or the absent parent must provide notarized consent. Plan ahead for deployment schedules.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Fountain or El Paso County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Fountain, Security, or Colorado Springs." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for El Paso County or military documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no 75-mile I-25 drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fountain address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Fountain, CO?", a: "Fast Passport Center offers emergency passport processing in Fountain, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to drive 75 miles up I-25 to the Aurora passport agency. Especially critical for military families on tight PCS timelines." },
    { q: "Do you handle official (military/government) passports?", a: "Fast Passport Center can assist with the expedited processing of official passports through our registered courier service. Military personnel at Fort Carson should verify with their command about specific official passport requirements. We handle the logistics so you can focus on your PCS preparation." },
    { q: "Does Fountain have its own passport acceptance facility?", a: "Yes — the Fountain Post Office (7745 S US Highway 85-87) offers passport acceptance services. For military personnel, the Fort Carson Post Office also provides acceptance services. Nearby options include the Colorado Springs Main Post Office and the El Paso County Clerk — both with more appointment availability." },
    { q: "What if I live on Fort Carson or in Security-Widefield?", a: "Absolutely. Fast Passport Center serves all of Fountain, Fort Carson, and Security-Widefield. Our service works the same way everywhere — ship your documents from any nearby UPS or FedEx location and we handle the rest." },
    { q: "Can you help with passports for military families PCSing overseas?", a: "Yes — this is one of our core services for the Fountain/Fort Carson community. We understand the unique timeline pressures of military PCS moves and can coordinate expedited passport services for the entire family. Military families are a priority for us." },
    { q: "How much does an expedited passport cost in Fountain, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote — we offer special consideration for military families on PCS orders." },
    { q: "Where can I get passport photos near Fountain?", a: "Walgreens and King Soopers in nearby Security and Colorado Springs offer passport photo services. UPS Store in Fountain and FedEx Office in Colorado Springs also provide photos. For military personnel, Fort Carson may offer photo services through MWR. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve all of southern El Paso County?", a: "Yes. Fast Passport Center serves the full southern El Paso County corridor including Fountain, Fort Carson, Security-Widefield, Stratmoor, Hanover, and all surrounding communities. Our courier service covers the entire region from Pueblo to Colorado Springs." },
  ],
  photoLocations: [
    { name: "Walgreens — Security", address: "6880 Mesa Ridge Pkwy, Fountain, CO 80817", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/" },
    { name: "King Soopers — Colorado Springs (South)", address: "2910 S Academy Blvd, Colorado Springs, CO 80916", hours: "Mon–Sun: 6AM–11PM", website: "https://www.kingsoopers.com/" },
    { name: "UPS Store — Fountain", address: "7710 S US Highway 85-87, Fountain, CO 80817", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Colorado Springs", address: "1750 E Woodmen Rd, Colorado Springs, CO 80920", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Colorado Springs (El Paso County)", address: "1675 W Garden of the Gods Rd, Colorado Springs, CO 80907", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV at the Citizens Service Center. REAL ID and driver's license renewals. Approximately 15 miles north of Fountain.", featured: true },
    { name: "DMV — Colorado Springs South (El Paso County)", address: "5650 Industrial Pl, Colorado Springs, CO 80916", hours: "Mon–Fri: 8AM–5PM", note: "South Colorado Springs DMV — closer to Fountain. REAL ID processing available. Convenient for Security-Widefield and Fountain residents.", featured: false },
  ],
  airports: [
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "15 miles north via I-25 — approximately 20 minutes",
      address: "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916",
      note: "Regional airport with domestic flights to major hubs including DEN, DFW, ATL, ORD, and PHX. Limited seasonal service. No international flights — all international travel requires a connection.",
      flightUrl: "https://www.flycos.com/",
      flightLabel: "COS Flight Info",
      featured: true,
    },
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "85 miles north via I-25 — approximately 1 hour 20 minutes",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights worldwide. Accessible from Fountain via I-25 north through Colorado Springs and Denver. The nearest major international airport to Fountain.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: false,
    },
  ],
};